import React from "react";
import { useField } from "formik";
import { FormControl, MenuItem, Select, SelectProps } from "@mui/material";
import { FieldError } from "../FieldError/FieldError";
import { CustomFieldLabel } from "../CustomFieldLabel/CustomFieldLabel";
import { styled } from "@mui/material/styles";

export function CustomFieldSelect({ name, label, required, placeholder, children, ...props }) {
  const [field, meta] = useField(name);

  return (
    <FormControl className="field-container" fullWidth={props.fullWidth}>
      {label && <CustomFieldLabel required={required}>{label}</CustomFieldLabel>}
      <StyledSelect
        {...field}
        {...props}
        displayEmpty
        $val={field.value}
        MenuProps={{
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
          PaperProps: { sx: { maxHeight: 320, borderRadius: "12px", mt: 0.5 } },
          ...props.MenuProps,
        }}
      >
      {placeholder && !required && <MenuItem value="" sx={{ color: 'var(--muted)' }}>{placeholder}</MenuItem>}
      {placeholder && required && <MenuItem value="" disabled>{placeholder}</MenuItem>}
        {children}
      </StyledSelect>
      {!!meta.touched && !!meta.error && <FieldError>{meta.error}</FieldError>}
    </FormControl>
  );
}

CustomFieldSelect.defaultProps = {
  label: "",
  required: false,
};

const StyledSelect = styled(Select)(({ theme, $val }) => ({
  display: "flex",
  height: "50px",
  alignItems: "center",
  border: "none !important",
  borderRadius: "12px",
  backgroundColor: "var(--Base-24, #F4F4F4)",
  fontFamily: "CircularStd",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "normal",
  color: "var(--Base-1000, #000)",
  outline: "none !important",
  boxShadow: "none !important",

  "& .MuiSelect-select": {
    padding: "10px",
    border: "none",
    outline: "none !important",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none !important",
  },

  "&:focus, &:active, &:hover": {
    border: "none !important",
    outline: "none !important",
    boxShadow: "none !important",
  },

  "& .MuiSelect-root": {
    border: "none !important",
  },

  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "none !important",
    },
    "&:hover fieldset": {
      border: "none !important",
    },
    "&.Mui-focused fieldset": {
      border: "none !important",
    },
  },

  "& .MuiInputBase-input": {
    opacity: $val ? 1 : 0.12,
  },

  "&:-webkit-autofill": {
    WebkitBoxShadow: "0 0 0px 1000px var(--Base-24, #F4F4F4) inset !important",
    backgroundColor: "var(--Base-24, #F4F4F4) !important",
    color: "var(--Base-300, #B0B0B0) !important",
    border: "none !important",
    transition: "background-color 5000s ease-in-out 0s",
  },
}));
